import { render } from "./Allocations.vue?vue&type=template&id=3dc206c3"
import script from "./Allocations.vue?vue&type=script&lang=js"
export * from "./Allocations.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/budget/Allocations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc206c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc206c3', __exports__)) {
    api.reload('3dc206c3', __exports__)
  }
  
  module.hot.accept("./Allocations.vue?vue&type=template&id=3dc206c3", () => {
    api.rerender('3dc206c3', render)
  })

}


export default __exports__